import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCategories } from '../../../redux/action/category/category'
import MainLoading from '../../../utils/MainLoading'
import DashboardMainTitle from '../../dashboardTitle/DashboardMainTitle'
import Wrapper from '../../dashboardWrapper/Wrapper'
import NewCategory from './newCategory/NewCategory'
import moment from "moment-jalaali";
import DashboardContent from '../../dashboardWrapper/DashboardContent'
import DeleteModal from './modals/DeleteModal'
import EditModal from './modals/EditModal'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';

const DashboardCategories = () => {
    const [show, setShow] = useState(true)
    const [modal, setModal] = useState({
        delete: false,
        edit: false,
        id: ''
    })
    const handleClick = () => { setShow(false) }
    const dispatch = useDispatch()
    const category = useSelector(state => state.category)
    const {t} = useTranslation();
    const lang = localStorage.getItem('lang')

    useEffect(() => {
        if(!category.category.length) {
            dispatch(fetchCategories())
        }
    }, [])

    const update = () => {
        setShow(false)
        setTimeout(function(){dispatch(fetchCategories())}, 1000)
    }

    const handleDelete = (id) => {
        setModal({ delete: true, id: id })
        setShow(true)
    }
    const handleEdit = (id) => {
        setModal({ edit: true, id: id })
        setShow(true)
    }

    return (
        <Wrapper>
            <DashboardContent>
                <DashboardMainTitle>{t("dashboard_nav_categories")}</DashboardMainTitle>

                {category.loading ? <MainLoading /> :
                    category.category.length ?
                        <div>
                            <Table bordered responsive>
                                <thead>
                                    <tr>
                                        <th>{t("category")}</th>
                                        <th>{t("products number")}</th>
                                        <th>{t("date")}</th>
                                        <th className='text-center'>{t("delete")}</th>
                                        <th className='text-center'>{t("edit")}</th>
                                        <th className='text-center'>{t("products")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {category.category.map(category => (
                                        <tr key={category.id}>
                                            <td>{category.name}</td>
                                            <td>{category.products_count}</td>
                                            <td>
                                                {lang === 'en' ?
                                                    category.created_at.substr(11, 5)+' - '+category.created_at && category.created_at.substr(0, 10)
                                                :
                                                    category.created_at.substr(11, 5)+' - '+moment(category.created_at && category.created_at.substr(0, 10), 'YYYY-M-D').format('jYYYY/jM/jD')
                                                }
                                            </td>
                                            <td className='text-center'><button className='btn btn-danger btn-sm px-3' onClick={id => handleDelete(category.id)}>{t("delete")} </button></td>
                                            <td className='text-center'><button className='btn btn-warning btn-sm px-3' onClick={id => handleEdit(category.id)}>{t("edit")} </button></td>
                                            <td className='text-center'><Link to={`/dashboard/category-products/${category.id}`} className='btn btn-primary btn-sm px-3'>{t("products")}</Link></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <NewCategory update={update} />
                        </div>
                    :
                    <div>
                        <h6 className='text-center my-2'>{t("There is no category")}</h6>
                        <NewCategory update={update} />
                    </div>
                }
            </DashboardContent>
            {modal.delete && <DeleteModal id={modal.id} show={show} handleClick={handleClick} update={update} />}
            {modal.edit && <EditModal id={modal.id} show={show} handleClick={handleClick} update={update} />}
        </Wrapper>
    )
}

export default DashboardCategories
